import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/cookies")({
  head: () => ({
    meta: [
      { title: "Política de Cookies — MEI Toolbox" },
      {
        name: "description",
        content:
          "Política de cookies do MEI Toolbox: entenda quais cookies e dados de armazenamento local são usados no navegador, para que servem e como controlá-los.",
      },
      { property: "og:title", content: "Política de Cookies — MEI Toolbox" },
      {
        property: "og:description",
        content:
          "Política de cookies do MEI Toolbox: entenda quais cookies e dados de armazenamento local são usados no navegador, para que servem e como controlá-los.",
      },
      { property: "og:url", content: "https://meitoolbox.com.br/cookies" },
    ],
    links: [{ rel: "canonical", href: "https://meitoolbox.com.br/cookies" }],
  }),
  component: CookiesPage,
});

function CookiesPage() {
  return (
    <article className="container mx-auto max-w-3xl px-4 py-12 prose prose-neutral">
      <h1 className="font-display text-4xl font-bold">Política de Cookies</h1>
      <p className="text-sm text-muted-foreground">
        Última atualização: {new Date().toLocaleDateString("pt-BR")}
      </p>

      <h2>O que são cookies?</h2>
      <p>
        Cookies são pequenos arquivos de texto que sites armazenam no seu navegador para lembrar de
        informações entre visitas. Tecnologias semelhantes incluem o <strong>localStorage</strong> e
        o <strong>sessionStorage</strong>, que também guardam dados localmente no seu dispositivo.
      </p>

      <h2>Como o MEI Toolbox usa cookies</h2>
      <p>
        O MEI Toolbox é 100% gratuito e <strong>não exige cadastro</strong>. Por isso, usamos o
        mínimo possível de cookies. As tecnologias que utilizamos são:
      </p>

      <h3>1. Armazenamento local (localStorage) — essencial</h3>
      <ul>
        <li>
          <strong>Marca da empresa</strong> (chave <code>mt:branding</code>): logo, nome, CNPJ e
          dados que você usa nos PDFs.
        </li>
        <li>
          <strong>Histórico de PDFs</strong> (chave <code>mt:docs</code>): metadados dos documentos
          que você gerou.
        </li>
        <li>
          <strong>Conversas com a IA MEI</strong> (chave <code>mt:chats</code>): suas perguntas e
          respostas anteriores.
        </li>
      </ul>
      <p>
        Esses dados ficam <strong>somente no seu navegador</strong>. Não são enviados para nossos
        servidores e não temos acesso a eles. Você pode apagar tudo a qualquer momento limpando os
        dados do site.
      </p>

      <h3>2. Cookies de terceiros e publicidade</h3>
      <p>
        O MEI Toolbox utiliza o serviço <strong>Google AdSense</strong> para exibir anúncios. O
        Google e seus parceiros usam cookies para veicular anúncios com base nas visitas anteriores
        dos usuários a este e/ou outros sites. O uso do cookie de publicidade pelo Google permite
        que ele e seus parceiros veiculem anúncios para os usuários com base nas visitas a este site
        e/ou a outros sites na Internet.
      </p>
      <p>
        Os usuários podem desativar a publicidade personalizada acessando as{" "}
        <a
          href="https://settings.google.com/ads/preferences"
          target="_blank"
          rel="noopener noreferrer"
        >
          Configurações de Anúncios do Google
        </a>
        . Alternativamente, você pode desativar o uso de cookies de terceiros para publicidade
        personalizada visitando o site{" "}
        <a href="https://optout.aboutads.info" target="_blank" rel="noopener noreferrer">
          aboutads.info
        </a>
        .
      </p>

      <h2>Como gerenciar / apagar</h2>
      <p>Você pode limpar os dados armazenados pelo MEI Toolbox a qualquer momento:</p>
      <ul>
        <li>
          No navegador: <em>Configurações → Privacidade → Limpar dados de navegação</em>.
        </li>
        <li>
          Apagando individualmente as chaves <code>mt:branding</code>, <code>mt:docs</code> e{" "}
          <code>mt:chats</code> no DevTools (aba <em>Application → Local Storage</em>).
        </li>
        <li>Em modo anônimo/privado, os dados são apagados quando você fecha a janela.</li>
      </ul>
      <p>
        Atenção: ao limpar esses dados você perderá sua marca personalizada, o histórico de PDFs e
        as conversas salvas com a IA MEI.
      </p>

      <h2>Alterações nesta política</h2>
      <p>
        Podemos atualizar esta política a qualquer momento. A data de "última atualização" no topo
        da página indica a versão vigente.
      </p>

      <h2>Contato</h2>
      <p>
        Dúvidas sobre esta política? Fale com a gente pela página de{" "}
        <Link to="/contato">contato</Link>. Veja também nossa{" "}
        <Link to="/privacidade">Política de Privacidade</Link> e os{" "}
        <Link to="/termos">Termos de Uso</Link>.
      </p>
    </article>
  );
}
